export default class Constants {
    public static PARAMETER_ATTRIBUTES = 'attrib';
    public static PARAMETER_PAGE = 'page';
    public static PARAMETER_SORTING = 'sorting';
    public static PARAMETER_ITEMS = 'items';
}
